import type { FlectoAnalyticsEvents } from '../events'
import { trackWithSegment } from '../provider'

export function segmentTrack<T extends keyof FlectoAnalyticsEvents>(
  eventName: T,
  payload: FlectoAnalyticsEvents[T]
) {
  trackWithSegment(eventName, payload)
}
